import { SetState, GetState } from 'zustand';
import createUnpaidBillsSlice, { IUnpaidBillsSlice } from './createUnpaidBillsSlice';
import createPaidBillsSlice, { IPaidBillsSlice } from './createPaidBillsSlice';
import createModalsSlice, { IModalsSlice } from './createModalsSlice';
import createUtilsSlice, { IBillUtilsSlice } from './createBillsUtilsSlice';

interface IBillsHubSliceMain {
  resetBillsHubSlices: () => void;
  showBillsHub: boolean;
  setShowBillsHub: (showBillsHub: boolean) => void;
}

export type IBillsHubSlice = IBillsHubSliceMain & IUnpaidBillsSlice & IPaidBillsSlice & IModalsSlice & IBillUtilsSlice;

const createBillsHubSlice = (set: SetState<IBillsHubSlice>, get: GetState<IBillsHubSlice>) => ({
  ...createUnpaidBillsSlice(set, get),
  ...createPaidBillsSlice(set, get),
  ...createModalsSlice(set),
  ...createUtilsSlice(set, get),
  resetBillsHubSlices: () => {
    get().resetUnpaidBillsSlice();
    get().resetPaidBillsSlice();
    get().resetModalsSlice();
    get().resetBillUtilsSlice();
  },
  showBillsHub: false,
  setShowBillsHub: (showBillsHub: boolean) => {
    set({ showBillsHub });
  },
});

export default createBillsHubSlice;
